import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getBusEnt = createAsyncThunk(
  "creditLimit/getBusEnt",
  async (statusId) => {
    const formattedStatusId = Array.isArray(statusId) ? statusId.join(",") : statusId;
    const response = await axios.get(
      `/api/admin/getBusEnt?statusId=${formattedStatusId}`
    );
    return response.response;
  }
);

export const addBusEnt = createAsyncThunk(
  "creditLimit/addBusEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/addBusEnt", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const approveBusEntbyId = createAsyncThunk(
  "creditLimit/approveBusEntbyId",
  async (arg) => {
    let query = "";
    if (typeof arg === "object" && arg !== null) {
      const params = new URLSearchParams();
      if (arg.busEntId) params.append("busEntId", arg.busEntId);
      if (arg.requestId) params.append("requestId", arg.requestId);
      query = params.toString();
    } else if (arg) {
      query = `busEntId=${encodeURIComponent(arg)}`;
    }
    const response = await axios.get(
      `/api/admin/getAapproveBusEnt?${query}`
    );
    return response.response;
  }
);

export const approveBusEnt = createAsyncThunk(
  "creditLimit/approveBusEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/approveBusEnt", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const enhanceBusEnt = createAsyncThunk(
  "creditLimit/enhanceBusEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/enhanceBusEnt", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const rejectBusEnt = createAsyncThunk(
  "creditLimit/rejectBusEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/rejectBusEnt`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const deativateBusEnt = createAsyncThunk(
  "creditLimit/deativateBusEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/deativateBusEnt`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const activateBusEnt = createAsyncThunk(
  "creditLimit/activateBusEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/activateBusEnt`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const reopenBusEnt = createAsyncThunk(
  "creditLimit/reopenBusEnt",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/reopenBusEnt`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getActiveBusinessList = createAsyncThunk(
  "creditLimit/getActiveBusinessList",
  async (dealCategoryId, { rejectWithValue }) => {
    try {
      let url = "/api/admin/getActiveBus";
      if (dealCategoryId) {
        url += `?dealCategoryId=${encodeURIComponent(dealCategoryId)}`;
      }
      const response = await axios.get(url);
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getActiveEnterpriseList = createAsyncThunk(
  "creditLimit/getActiveEnterpriseList",
  async (arg, { rejectWithValue }) => {
    try {
      let url = "/api/admin/getActiveEnt";
      if (typeof arg === "object" && arg !== null) {
        const params = new URLSearchParams();
        if (arg.orgId) params.append("orgId", arg.orgId);
        if (arg.dealCategoryId) params.append("dealCategoryId", arg.dealCategoryId);
        url += `?${params.toString()}`;
      } else {
        url += `?orgId=${arg}`;
      }
      const response = await axios.get(url);
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getDealCategoryList = createAsyncThunk(
  "creditLimit/getDealCategoryList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getDealCategory");
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getPlatformFeeData = createAsyncThunk(
  "creditLimit/getPlatformFeeData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getPlatformFee");
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busEntDetailedView = createAsyncThunk(
  "creditLimit/busEntDetailedView",
  async (busEntId) => {
    const response = await axios.get(
      `/api/admin/busEntDetailedView?busEntId=${busEntId}`
    );
    return response.response;
  }
);

export const editBusEntDets = createAsyncThunk(
  "creditLimit/editBusEntDets",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/editBusEntDets", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const reUploadConsent = createAsyncThunk(
  "enterprise/reUploadConsent",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/uploadConsent`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const addCheckBox = createAsyncThunk(
  "creditLimit/addCheckBox",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/checkbox", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const deleteCheckBox = createAsyncThunk(
  "creditLimit/deleteCheckBox",
  async (checkboxId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/api/admin/checkbox/${checkboxId}`);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getCreditLimitRequests = createAsyncThunk(
  "creditLimit/getCreditLimitRequests",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/creditLimit/requests");
      const list = response?.response ?? response?.data ?? response;
      return Array.isArray(list) ? list : [];
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const approveCreditLimitRequest = createAsyncThunk(
  "creditLimit/approveCreditLimitRequest",
  async ({ requestId, payload }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/creditLimit/request/${requestId}/approve`,
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const rejectCreditLimitRequest = createAsyncThunk(
  "creditLimit/rejectCreditLimitRequest",
  async ({ requestId, payload }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/creditLimit/request/${requestId}/reject`,
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const reopenCreditLimitRequest = createAsyncThunk(
  "creditLimit/reopenCreditLimitRequest",
  async ({ requestId, payload }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/creditLimit/request/${requestId}/reopen`,
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const creditLimitSlice = createSlice({
  name: "creditLimit",
  initialState: {
    loading: false,
    error: "",
    creditLimitData: [],
    entBusSubmitLoading: false,
    addSubmitLoading: false,
    deleteLoading: false,
    activeBusList: [],
    activeEntList: [],
    dealCategoryList: [],
    busEntByIdLoading: false,
    busEntByIdData: {},
    approveSubmitLoading: false,
    enhanceSubmitLoading: false,
    commentSubmitLoading: false,
    commentSubmitError: "",
    platformFeeData: [],
    busEntDetailedData: {},
    editBusEntSaveLoading: false,
    requestsLoading: false,
    requestsData: [],
    requestApproveLoading: false,
    requestRejectLoading: false,
    requestReopenLoading: false,
    requestsError: ""
  },
  extraReducers: (builder) => {
    builder.addCase(getBusEnt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getBusEnt.fulfilled, (state, action) => {
      state.loading = false;
      state.creditLimitData = action.payload;
    });
    builder.addCase(getBusEnt.rejected, (state, action) => {
      state.loading = false;
      state.creditLimitData = [];
      state.error = action.payload;
    });

    builder.addCase(addBusEnt.pending, (state) => {
      state.entBusSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(addBusEnt.fulfilled, (state, action) => {
      state.entBusSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(addBusEnt.rejected, (state, action) => {
      state.entBusSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(addCheckBox.pending, (state) => {
      state.addSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(addCheckBox.fulfilled, (state, action) => {
      state.addSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(addCheckBox.rejected, (state, action) => {
      state.addSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteCheckBox.pending, (state) => {
      state.deleteLoading = true;
      state.error = "";
    });
    builder.addCase(deleteCheckBox.fulfilled, (state, action) => {
      state.deleteLoading = false;
      state.error = "";
    });
    builder.addCase(deleteCheckBox.rejected, (state, action) => {
      state.deleteLoading = false;
      state.error = action.payload;
    });

    builder.addCase(approveBusEntbyId.pending, (state) => {
      state.busEntByIdLoading = true;
      state.error = "";
    });
    builder.addCase(approveBusEntbyId.fulfilled, (state, action) => {
      state.busEntByIdLoading = false;
      state.busEntByIdData = action.payload;
    });
    builder.addCase(approveBusEntbyId.rejected, (state, action) => {
      state.busEntByIdLoading = false;
      state.error = action.payload;
    });

    builder.addCase(approveBusEnt.pending, (state) => {
      state.approveSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(approveBusEnt.fulfilled, (state, action) => {
      state.approveSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(approveBusEnt.rejected, (state, action) => {
      state.approveSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(enhanceBusEnt.pending, (state) => {
      state.enhanceSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(enhanceBusEnt.fulfilled, (state, action) => {
      state.enhanceSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(enhanceBusEnt.rejected, (state, action) => {
      state.enhanceSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(rejectBusEnt.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(rejectBusEnt.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(rejectBusEnt.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(deativateBusEnt.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(deativateBusEnt.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(deativateBusEnt.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(reopenBusEnt.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(reopenBusEnt.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(reopenBusEnt.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(activateBusEnt.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(activateBusEnt.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(activateBusEnt.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(getActiveBusinessList.fulfilled, (state, action) => {
      state.activeBusList = action.payload;
    });

    builder.addCase(getActiveEnterpriseList.fulfilled, (state, action) => {
      state.activeEntList = action.payload;
    });

    builder.addCase(getPlatformFeeData.fulfilled, (state, action) => {
      state.platformFeeData = action.payload;
    });

    builder.addCase(getDealCategoryList.fulfilled, (state, action) => {
      state.dealCategoryList = action.payload;
    });

    builder.addCase(reUploadConsent.pending, (state) => {
      state.error = "";
    });
    builder.addCase(reUploadConsent.fulfilled, (state, action) => {
      state.error = "";
    });
    builder.addCase(reUploadConsent.rejected, (state, action) => {
      state.error = action.payload;
    });

    builder.addCase(busEntDetailedView.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(busEntDetailedView.fulfilled, (state, action) => {
      state.loading = false;
      state.busEntDetailedData = action.payload;
    });
    builder.addCase(busEntDetailedView.rejected, (state, action) => {
      state.loading = false;
      state.busEntDetailedData = [];
      state.error = action.payload;
    });

    builder.addCase(editBusEntDets.pending, (state) => {
      state.editBusEntSaveLoading = true;
      state.error = "";
    });
    builder.addCase(editBusEntDets.fulfilled, (state, action) => {
      state.editBusEntSaveLoading = false;
      state.error = "";
    });
    builder.addCase(editBusEntDets.rejected, (state, action) => {
      state.editBusEntSaveLoading = false;
      state.error = action.payload;
    });

    // getCreditLimitRequests
    builder.addCase(getCreditLimitRequests.pending, (state) => {
      state.requestsLoading = true;
      state.requestsError = "";
    });
    builder.addCase(getCreditLimitRequests.fulfilled, (state, action) => {
      state.requestsLoading = false;
      state.requestsData = Array.isArray(action.payload) ? action.payload : [];
    });
    builder.addCase(getCreditLimitRequests.rejected, (state, action) => {
      state.requestsLoading = false;
      state.requestsError = action.payload;
      state.requestsData = [];
    });

    // approveCreditLimitRequest
    builder.addCase(approveCreditLimitRequest.pending, (state) => {
      state.requestApproveLoading = true;
      state.requestsError = "";
    });
    builder.addCase(approveCreditLimitRequest.fulfilled, (state) => {
      state.requestApproveLoading = false;
    });
    builder.addCase(approveCreditLimitRequest.rejected, (state, action) => {
      state.requestApproveLoading = false;
      state.requestsError = action.payload;
    });

    // rejectCreditLimitRequest
    builder.addCase(rejectCreditLimitRequest.pending, (state) => {
      state.requestRejectLoading = true;
      state.requestsError = "";
    });
    builder.addCase(rejectCreditLimitRequest.fulfilled, (state) => {
      state.requestRejectLoading = false;
    });
    builder.addCase(rejectCreditLimitRequest.rejected, (state, action) => {
      state.requestRejectLoading = false;
      state.requestsError = action.payload;
    });

    // reopenCreditLimitRequest
    builder.addCase(reopenCreditLimitRequest.pending, (state) => {
      state.requestReopenLoading = true;
      state.requestsError = "";
    });
    builder.addCase(reopenCreditLimitRequest.fulfilled, (state) => {
      state.requestReopenLoading = false;
    });
    builder.addCase(reopenCreditLimitRequest.rejected, (state, action) => {
      state.requestReopenLoading = false;
      state.requestsError = action.payload;
    });
  },

  reducers: {
    updateErrorStatus(state) {
      state.error = "";
      state.commentSubmitError = "";
      state.requestsError = "";
    },
    clearActiveBusList(state) {
      state.activeBusList = [];
    },
    clearActiveEntList(state) {
      state.activeEntList = [];
    },
  },
});

export const { updateErrorStatus, clearActiveBusList, clearActiveEntList } =
  creditLimitSlice.actions;

export default creditLimitSlice.reducer;
